"use strict";

/*
 * indicative-parser
 *
 * (c) Harminder Virk <virk@adonisjs.com>
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
*/
Object.defineProperty(exports, "__esModule", {
  value: true
});
var array_1 = require("./array");
exports.array = array_1.array;
var boolean_1 = require("./boolean");
exports.boolean = boolean_1.boolean;
var number_1 = require("./number");
exports.number = number_1.number;
var object_1 = require("./object");
exports.object = object_1.object;
var schema_1 = require("./schema");
exports.schema = schema_1.schema;
var schema_2 = require("./schema");
exports.new = schema_2.schema;
var string_1 = require("./string");
exports.string = string_1.string;
var tuple_1 = require("./tuple");
exports.tuple = tuple_1.tuple;